import { apiRequest, serviceFeatureUpdate, serviceFeatureDetail, serviceList } from "../../../../services/adapters/base";

class UpdateRepository {
  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      serviceFeatureUpdate,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      serviceFeatureDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchPortalServices = async (query) => {
    return await apiRequest(
      "get",
      serviceList,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
